import type { AnalyticsSurface } from '@/shared/surfaces/AnalyticsSurface';
import ClassificationSurfaceCard from '@/features/classification/ClassificationSurfaceCard';
import { GOVERNANCE_CATALOG } from './GovernanceTopicCatalog';

/**
 * The Governance surface: header copy, the topic catalog, and the drill-in
 * treatment. The landing is rendered by `GovernanceLayout` (the left-rail shell),
 * so no `registerBody` is needed here; this definition backs `useSurface`, the
 * topic/evidence drill-ins, and search.
 */
export const GOVERNANCE_SURFACE: AnalyticsSurface = {
    id: 'governance',
    basePath: '/governance',
    title: 'Governance',
    subtitle: 'Your governance policies and how the org is holding to them — status, activity, and the prompts behind each one.',
    catalog: GOVERNANCE_CATALOG,
    gallery: { lead: 'none', cardStyle: 'compact', columns: { base: 1 } },
    assist: true,
    trailingCard: <ClassificationSurfaceCard category="Governance" variant="compact" />,
};
